import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, Subject } from 'rxjs';

/**
 * the signal subject indicates that there are changes that are not updated in this instance
 */
export class ErrorListService {
  parent: ErrorListService | undefined;
  name: string;

  private signalSubject = new Subject<void>();
  public signal$ = this.signalSubject.asObservable();

  private readonly errors = new BehaviorSubject<string[]>([]);
  public readonly errors$ = this.errors.asObservable();

  private children: Map<string, ErrorListService> = new Map<
    string,
    ErrorListService
  >();
  private errorListWithChildren: string[] = [];
  private errorList: string[] = [];
  private formControl = new FormControl<boolean>(true, Validators.requiredTrue);
  public readonly formGroup = new FormGroup({ errors: this.formControl });

  private constructor(parent: ErrorListService | undefined, name: string) {
    this.parent = parent;
    this.name = name;

    this.signal$.subscribe(() => {
      const childrenErrors = Array.from(this.children.values())
        .map((e) => e.errorListWithChildren)
        .flat();
      this.errorListWithChildren = [...this.errorList, ...childrenErrors];
      this.formControl.setValue(this.errorListWithChildren.length == 0);
      this.errors.next(this.errorListWithChildren);
      if (this.parent) {
        this.parent.signalSubject.next();
      }
    });
  }

  public static create() {
    return new ErrorListService(undefined, 'root');
  }

  public create(name: string) {
    let child = this.children.get(name);
    if (child) {
      return child;
    }
    child = new ErrorListService(this, name);
    this.children.set(name, child);
    return child;
  }

  public deleteAllAndCreate(name: string) {
    this.children.clear();
    this.signalSubject.next();
    return this.create(name);
  }

  public addError(error: string) {
    if (!this.errorList.includes(error)) {
      this.errorList.push(error);
    }
    this.signalSubject.next();
  }

  public removeError(error: string) {
    this.errorList = this.errorList.filter((err) => err != error);
    this.signalSubject.next();
  }

  public removeAllErrors() {
    this.errorList = [];
    this.children.forEach((child) => child.removeAllErrors());
    if (this.children.size == 0) {
      this.signalSubject.next();
    } // if there are children, they will trigger the signal and it will propagate
  }
}
